import Vue from 'vue'
import { apolloClient } from '@/apollo'
import gql from 'graphql-tag'

export const fetchSupplierMatchQuery = gql`
  query SupplierMatch($from: timestamptz, $to: timestamptz, $supplier_id: uuid, $limit: Int!, $offset: Int!) {
    report_match_aggregate(where: { created_at: { _gte: $from, _lte: $to}, supplier_id: { _eq: $supplier_id }}) {
      aggregate {
        count
      }
    }
    report_match(where: { created_at: { _gte: $from, _lte: $to}, supplier_id: { _eq: $supplier_id }}, order_by: { created_at: desc}, limit: $limit, offset: $offset) {
      buyer_username
      buyer_name
      buyer_taxid
      item_description
      item_price
      item_currency
      item_uom
      item_sku
      item_classname
      item_classcode
      search_words
      supplier_name
      supplier_taxid
      created_at
    }
  }
`

export const fetchBuyerRequestsQuery = gql`
  query BuyerRequests($from: timestamptz, $to: timestamptz, $buyer_id: uuid, $number: String, $limit: Int!, $offset: Int!) {
    requests_report_aggregate(where: { created_at: { _gte: $from, _lte: $to}, buyer_id: { _eq: $buyer_id }, number: { _eq: $number}}) {
      aggregate {
        count
      }
    }
    requests_report(where: { created_at: { _gte: $from, _lte: $to}, buyer_id: { _eq: $buyer_id }, number: { _eq: $number}}, order_by: { created_at: desc}, limit: $limit, offset: $offset) {
      id
      number
      search_words
      request_name
      answered_at
      readed_at
      created_at
      close_date
      buyer_username
      buyer_useremail
      buyer_name
      buyer_taxid
      item_description
      item_classname
      item_classcode
      supplier_name
      supplier_taxid
      supplier_username
      supplier_useremail
      created_at
    }
  }
`
const report = {
  namespaced: true,
  state: {
    supplier_match: [],
    supplier_match_count: 0,
    buyer_requests: [],
    buyer_requests_count: 0
  },
  actions: {
    async fetchSupplierMatch ({ commit }, filter) {
      try {
        const requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchSupplierMatchQuery,
          variables: {
            from: filter.from,
            to: filter.to,
            limit: filter.limit,
            offset: filter.offset
          }
        }

        if (filter.supplierId) {
          requestQuery.variables.supplier_id = filter.supplierId
        }

        const result = await apolloClient.query(requestQuery)
        if (result && result.data) {
          commit('SET_SUPPLIERMATCH', result.data.report_match)
          commit('SET_SUPPLIERMATCH_COUNT', result.data.report_match_aggregate.aggregate.count)
        }
      } catch (err) {
        window.console.error(err)
      }
    },
    async fetchBuyerRequests ({ commit }, filter) {
      try {
        const requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchBuyerRequestsQuery,
          variables: {
            from: filter.from,
            to: filter.to,
            limit: filter.limit,
            offset: filter.offset
          }
        }

        if (filter.buyerId) {
          requestQuery.variables.buyer_id = filter.buyerId
        }

        if (filter.number) {
          requestQuery.variables.number = filter.number
        }

        const result = await apolloClient.query(requestQuery)
        if (result && result.data) {
          commit('SET_BUYERREQUESTS', result.data.requests_report)
          commit('SET_BUYERREQUESTS_COUNT', result.data.requests_report_aggregate.aggregate.count)
        }
      } catch (err) {
        window.console.error(err)
      }
    }
  },
  mutations: {
    SET_SUPPLIERMATCH (state, data) {
      Vue.set(state, 'supplier_match', data)
    },
    SET_SUPPLIERMATCH_COUNT (state, data) {
      Vue.set(state, 'supplier_match_count', data)
    },
    SET_BUYERREQUESTS (state, data) {
      Vue.set(state, 'buyer_requests', data)
    },
    SET_BUYERREQUESTS_COUNT (state, data) {
      Vue.set(state, 'buyer_requests_count', data)
    }
  },
  getters: {
    supplierMatchInfo: state => state.supplier_match,
    supplierMatchCountInfo: state => state.supplier_match_count,
    buyerRequestsInfo: state => state.buyer_requests,
    buyerRequestsCountInfo: state => state.buyer_requests_count
  }
}

export default report



// WEBPACK FOOTER //
// ./src/store/modules/report.js